/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
// import { API_URL } from "~/components/shared-components/MasonryLayout";
export const API_URL = 'https://picsum.photos/v2/list';

import { PageDetailsType } from '~/type';

interface ImageGalleryInitState {
  data: any[];
  loading: boolean;
}

export const getImagesData = createAsyncThunk<any, PageDetailsType>(
  'imageGallery/getImageData',
  async (pageDetails) => {
    const response = await axios.get(
      `${API_URL}?page=${pageDetails.page}&limit=${pageDetails.pageSize}`
    );
    return response.data;
  }
);

const initialState: ImageGalleryInitState = {
  data: [],
  loading: false,
};

const headerSlice = createSlice({
  name: 'imageGallery',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getImagesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getImagesData.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getImagesData.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default headerSlice.reducer;
